import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { type SiteLocationState, setSelectedSiteLocation } from "~/store/siteLocationSlice";
import { TaskAssignmentsSsrmRow } from "~produce/labor/tasks/helpers/taskAssignmentsSsrmRow";

type TaskAssignmentNode = TaskAssignmentsSsrmRow;

export type TaskAdminFormMode = "idle" | "create" | "dueDate" | "reassign";

interface TaskAdminState {
	areAllSitesChosen: boolean;
	formMode: TaskAdminFormMode;
	selectedTask?: TaskAssignmentNode;
}

const initialState: TaskAdminState = {
	areAllSitesChosen: false,
	formMode: "idle"
};

const taskAdminSlice = createSlice({
	extraReducers: (builder) => {
		builder.addCase(setSelectedSiteLocation, (state) => {
			state.areAllSitesChosen = false;
		});
	},
	initialState,
	name: "taskAdmin",
	reducers: {
		closeTaskAdminForm: (state) => {
			state.formMode = "idle";
		},
		openChangeDueDate: (state, action: PayloadAction<TaskAssignmentNode>) => {
			state.selectedTask = action.payload;
			state.formMode = "dueDate";
		},
		openCreateTask: (state) => {
			state.formMode = "create";
		},
		openReassignTask: (state, action: PayloadAction<TaskAssignmentNode>) => {
			state.selectedTask = action.payload;
			state.formMode = "reassign";
		},
		setAllTaskSitesChosen: (state) => {
			state.areAllSitesChosen = true;
		},
		setSelectedTask: (state, action: PayloadAction<TaskAssignmentNode | undefined>) => {
			state.selectedTask = action.payload;
		}
	}
});

export const {
	closeTaskAdminForm,
	openChangeDueDate,
	openCreateTask,
	openReassignTask,
	setAllTaskSitesChosen,
	setSelectedTask
} = taskAdminSlice.actions;

export const selectTaskSiteLocationId = (state: {
	siteLocation: Pick<SiteLocationState, "selectedSiteLocationId">;
	taskAdmin: Pick<TaskAdminState, "areAllSitesChosen">;
}): string | null => (state.taskAdmin.areAllSitesChosen ? null : state.siteLocation.selectedSiteLocationId);

export type { TaskAssignmentNode };

export default taskAdminSlice.reducer;
